export class FederatedConnection {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "glue",
            "baseName": "glue",
            "type": "FederatedGlueConnection",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return FederatedConnection.attributeTypeMap;
    }
    constructor() {
    }
}
